import { Equipe } from './../models/equipe.model';
import { DesafioHackathon } from './../models/hackathon.model';
import { Hackathon, EntregaHackathon } from '../models/hackathon.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { PerfilHackathon } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class HelpersService {

  private hackathon: Hackathon;
  private equipeId: string;

  constructor(private router: Router,
              private snackBar: MatSnackBar) {
    if (this.isNullOrUndefined(this.hackathon)) {
      this.routeToLogin();
    }
  }

  openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  /// Hackathon General Functions ///

  setEquipeId(equipeId: string): void {
    this.equipeId = equipeId;
  }

  getEquipeId(): string {
    return this.equipeId;
  }

  setHackathon(hackathonOnline: Hackathon): void {
    this.hackathon = hackathonOnline;
  }

  comparaDataHora(inicio: Date, fim: Date): boolean {
    if (inicio < fim) {
      return true;
    } else {
      return false;
    }
  }

  get hackathonAtivo(): boolean {
    return this.hackathon.ativo;
  }

  get hackathonId(): string {
    return this.hackathon.id;
  }

  get hackathonNome(): string {
    return this.hackathon.nome;
  }

  get hackathonDescricao(): string {
    return this.hackathon.descricao;
  }

  get hackathonEntregas(): EntregaHackathon[] {
    return this.hackathon.entregas;
  }

  get hackathonDesafios(): DesafioHackathon[] {
    return this.hackathon.desafios;
  }

  get hackathonDataInicio(): Date {
    return new Date(this.hackathon.dataInicio); // UTC time
  }

  get hackathonDataTermino(): Date {
    return new Date(this.hackathon.dataTermino); // UTC time
  }

  get hackathonLiberarDesaios(): boolean {
    return this.hackathon.liberarDesafios;
  }

  get hackathonLiberarEntregas(): boolean {
    return this.hackathon.liberarEntregas;
  }

  get hackathonLiberarResultado(): boolean {
    return this.hackathon.liberarResultado;
  }

  get hackathonLiberarCriacaoDeEquipes() {
    return this.hackathon.liberarCriacaoEquipes;
  }

  /// Validators ///

  isNullOrUndefined(data: any): boolean {
    if (data === null || data === undefined) {
      return true;
    } else {
      return false;
    }
  }

  mostrarPerfil(perfil: number): void {
    switch (perfil) {
      case 0: // admin
        this.openSnackBar('Você já tem acesso a toda a plataforma Admin!', '');
        this.routeToDetalhes();
        break;
      case 1: // participante
        this.openSnackBar('Você atualmente é um participante!', '');
        break;
      case 2: // mentor
        this.openSnackBar('Você atualmente é um mentor!', '');
        break;
      case 3: // avaliador
        this.openSnackBar('Você atualmente é um avaliador!', '');
        break;
    }
  }

  /// Routers ///

  routeToLogin = () => this.router.navigate(['/']);
  routeToDetalhes = () => this.router.navigate(['/detalhes']);

  routeToMudarPerfil = () => this.router.navigate(['/perfil']);

  routeToMentoria = () => this.router.navigate(['/mentoria']);
  routeToCriarTopicoMentoria = () => this.router.navigate(['/criar-topico']);
  routeToTopicoMentoria = (questaoId: string) => this.router.navigate([`/topico/${questaoId}`]);

  routeToEquipes = () => this.router.navigate(['/equipes']);
  routeToResumoEquipe = (nomeEquipe: string) => this.router.navigate([`/equipe/${nomeEquipe}`]);
  routeToEscolhaDesafio = (nomeEquipe: string) => this.router.navigate([`/desafios/${nomeEquipe}`]);
  routeToEntregas = (nomeEquipe: string) => this.router.navigate([`/entregas/${nomeEquipe}`]);

  routeToAvaliacoes = () => this.router.navigate(['/avaliacoes']);

  redirecionarAoSelecionarPerfil(perfil: number): void {
    switch (perfil) {
      case 1: this.routeToEquipes(); break;
      case 2: this.routeToMentoria(); break;
      case 3: this.routeToAvaliacoes(); break;
    }
  }

}
